module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Medium.d6f5f2a2.woff2";